/**
 * Created by ws7 on 2017/6/12.
 */

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import common from './common';
import systemEvent from './systemEvent';
import image from './image';
import disk from './disk';
import snap from './snap';
import kec from './kec';
import avoid from './avoid';
import exclusive from './exclusive';
import snapStrategy from './snapStrategy';
import eip from './eip';
import project from './project';
import ssh from './ssh';
// import step1 from "public-business-components/src/store/create/step1/index";
// import step3 from "public-business-components/src/store/create/step3/index";
// import step4 from "public-business-components/src/store/create/step4/index";
// import pcommon from "public-business-components/src/store/common/index";
import recycle from './recycle';
import launchTemplate from './launchTemplate';
import reservedInstance from './reservedInstance';

import publicBusinessComponents from 'public-business-components';

export default new Vuex.Store({
    modules: Object.assign({
        common,
        systemEvent,
        image,
        disk,
        kec,
        avoid,
        exclusive,
        snap,
        snapStrategy,
        eip,
        project,
        ssh,
        recycle,
        launchTemplate,
        reservedInstance,

        // 旧逻辑
        // pcommon,
        // step1,
        // step3,
        // step4,

        // 新命名空间
    }, publicBusinessComponents.exportStore())
});



